<template>
  <div>
    <!-- <loading-mask v-show="loading" /> -->
    <image-dynamic-effects v-if="uploadComplete" :imageObj="uploadImageInfo" @back="handleBack"
      @processed="handleProcessed" />
    <image-upload @uploadComplete="handleUploadComplete" v-else />
  </div>
</template>
<script setup>
import ImageUpload from "./image-upload.vue";
import imageDynamicEffects from "@/components/models/imageDynamicEffects.vue";
import LoadingMask from "@/components/boolv-ui/loading-mask/index.vue";
import { ref, onMounted } from "vue";
import { eventTracking } from "@/utils/eventTracking.js";
import { useCheckResourceStore } from "@/store";
import { authenticator } from "@/utils";

const { deductResourceFn } = useCheckResourceStore();
const uploadComplete = ref(false);
const uploadImageInfo = ref({});
const loading = ref(false);

const handleUploadComplete = async (imageObj) => {
  eventTracking("booltool_page_upload", { tool_name: "animation", is_batch: false });
  await deductResourceFn('PHOTO_ANIMATION_EFFECTS', false);
  await authenticator.refresh();
  uploadComplete.value = true;
  uploadImageInfo.value = imageObj;
};

const handleBack = () => {
  uploadImageInfo.value = {};
  uploadComplete.value = false;
};
const handleProcessed = () => {
  loading.value = false;
}


</script>

<style lang="less"></style>
